<template>
  <div id="app">

    <!--<router-link to="/">Index</router-link>
    <router-link to="/login">Login</router-link>
    <router-link to="/signup">Signup</router-link>-->
    <router-view />

    <!-- <Plan v-if="is_reservation"/>
      <index  />
   -->
  </div>
</template>

<script>
import Register from './components/Register.vue'
import Login from './components/Login.vue'
import index from './components/index.vue'
import Plan from './components/Plan.vue'
// import Login from './components/authentification/Login.vue'
// import Signup from './components/authentification/Signup.vue'


export default {
  name: 'App',
  components: {
    index,
    Plan,

    // Login,
    // Signup

  },
  beforeCreate() {
    // this.$OneSignal.showSlidedownPrompt()
  },
  computed:{
    is_reservation(){
      
      return window.location.href.includes("/reservations/")
      
    },
    is_auth(){
      
      return window.location.href.includes("/login")
      
    },
    is_register(){
      
      return window.location.href.includes("/register")
      
    }
  },
  async created() {
    // await WsSubscriptions()
  },
  methods:{
    handleAboutMessageEvent(data){
    
    }
  },
  mounted(){
    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
}
body{
  padding: 0px ;
  margin: 0px;
}

</style>
